import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconPause",
  "use": "IconPause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"IconPause\"><g clip-path=\"url(#IconPause_clip0)\"><path d=\"M16 32A16 16 0 100 16a16.017 16.017 0 0016 16zm-6.315-9.945V11.388a2 2 0 012-2h.63a2 2 0 012 2v10.667a2 2 0 01-2 2h-.63a2 2 0 01-2-2zm7.926-10.667a2 2 0 012-2h.704a2 2 0 012 2v10.667a2 2 0 01-2 2h-.704a2 2 0 01-2-2V11.388z\" /></g><defs><clipPath id=\"IconPause_clip0\"><path d=\"M0 0h32v32H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol